import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../theme';

const useProfilePictureSelectorStyles = makeStyles()(() => ({
  profilePicSelector: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.gap.m,
    justifyContent: 'flex-start',
    padding: `${theme.padding.m} 0`,
    flexWrap: 'wrap',
    alignSelf: 'center',
  },
  selectedPic: {
    'height': theme.iconSize,
    'width': 'auto',
    'cursor': 'pointer',
    'border': theme.border,
    'borderColor': theme.primary.light,
    'boxShadow': theme.buttonShadow(theme.primary.light),
    '&:hover': {
      borderColor: theme.primary.dark,
      boxShadow: theme.buttonShadow(theme.primary.dark),
    },
  },
  profilePic: {
    'height': theme.iconSize,
    'width': 'auto',
    'cursor': 'pointer',
    'border': theme.border,
    '&:hover': {
      borderColor: theme.primary.lighter,
      boxShadow: theme.buttonShadow(colors.gray['400']),
    },
  },
}));

export default useProfilePictureSelectorStyles;
